/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface ISteps {
  stepDescription?: string;
  stepImage?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class Steps extends Component {
  private readonly stepList: ISteps[] = [
    {
      stepDescription:
        'paper<br/>crayons or markers<br/>flashlight or sunlight<br/>toys!',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZZv',
    },
    {
      stepDescription:
        'Let your toys stand their ground anywhere they want, as long as they cast a shadow onto the paper.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZZu',
    },
    {
      stepDescription: 'Trace the outline of the shadow for each toy.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Us6',
    },
    {
      stepDescription:
        'Add some color and you can even add your own background to really create a scene!',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1XsU',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <h5 className='diy-small-heading-padding0'>What You’ll Need:</h5>

          {this.stepList.map((item) => (
            <React.Fragment>
              <div className='col-lg-12 col-md-12'>
                <div className='step-text'>
                  <p>{ReactHtmlParser(item.stepDescription)}</p>
                </div>
              </div>
              <div className='col-lg-12 col-md-12'>
                <div className='step-image'>
                  <img
                    className='img-responsive'
                    src={item.stepImage}
                    alt='bay doll sleeping bag'
                  />
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default Steps;
